import useEventListingStore from 'layout/Listing/variants/events/store';

import { hasArrayValues } from 'utils/array/arrays';
import { toKebabCase } from 'utils/strings';

const checkFilters = (event: { data: EventResource }, filters: string[]) => {
  const tags = toKebabCase(event.data?.tags?.value.data.label || '');

  return filters.reduce((acc, filter) => {
    const isFiltered =
      hasArrayValues(filters) && filters.some(filterValue => filterValue && tags.includes(toKebabCase(filterValue)));

    return {
      ...acc,
      [filter]: isFiltered,
    };
  }, {});
};

const useFilterEvents = (allEvents: { data: EventResource }[]) => {
  const activeFilters = useEventListingStore(state => state.filters);
  const search = useEventListingStore(state => state.search);

  if (!hasArrayValues(activeFilters) && !search) {
    return allEvents;
  }

  const filteredEvents = allEvents.filter(event => {
    const isFiltered = checkFilters(event, activeFilters);
    const isFilteredValues = Object.values(isFiltered);

    return !isFilteredValues.includes(false);
  });

  const searchedEvents = filteredEvents.filter(event =>
    event?.data?.title?.toLowerCase().includes(search.toLowerCase()),
  );

  return searchedEvents;
};

export default useFilterEvents;
